// RSS COMMERCE — shared interactions (FAQ accordion, video play/pause).
// Ported from rss-commerce-demo/assets/js/app.js. Scoped per-instance so the
// section can be added more than once in the theme editor. Multiple rss-*
// sections (rss-faq, rss-video) each render their own <script src> for this
// file — guard against re-running init() if the page includes it twice.
(function () {
  'use strict';
  if (window.__rssInteractionsLoaded) return;
  window.__rssInteractionsLoaded = true;

  function initFaq(root) {
    var toggles = root.querySelectorAll('[data-rss-faq-toggle]');

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-rss-faq-toggle');
        var answer = root.querySelector('[data-rss-faq-answer="' + index + '"]');
        var chevron = btn.querySelector('[data-rss-faq-chevron]');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        toggles.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var c = b.querySelector('[data-rss-faq-chevron]');
          if (c) c.classList.remove('is-open');
        });
        root.querySelectorAll('[data-rss-faq-answer]').forEach(function (a) {
          a.hidden = true;
        });

        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          if (chevron) chevron.classList.add('is-open');
          if (answer) answer.hidden = false;
        }
      });
    });
  }

  function initVideoToggle(btn) {
    btn.addEventListener('click', function () {
      var pressed = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', String(!pressed));
    });
  }

  function init() {
    document.querySelectorAll('[data-rss-faq]').forEach(initFaq);
    document.querySelectorAll('[data-rss-video-toggle]').forEach(initVideoToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
